<template>
  <el-container style="width: 85%; margin: 10px auto 0;">
    <el-header>
      <el-row justify="space-between">
        <el-col :span="6">
          <el-image :src="logoImgUrl"></el-image>
        </el-col>
        <el-col :span="4" :offset="14">
        <el-dropdown @command="selectDropDown">
          <el-button plain type="info">
            {{ $store.state.username }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">ログアウト</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </el-col>
      </el-row>
    </el-header>
    <el-main style="padding: 5px">
      <notice></notice>
      <nav-menu></nav-menu>
      <router-view/>
    </el-main>
  </el-container>
</template>

<script>
import LogoImgUrl from '@/assets/BUYMeister.png'
import NavMenu from '@/components/NavMenu.vue'
import Notice from '@/components/Notice.vue'

export default {
  data: function () {
    return {
      logoImgUrl: LogoImgUrl
    }
  },
  components: {
    navMenu: NavMenu,
    notice: Notice
  },
  methods: {
    selectDropDown: function (command) {
      this.$store.dispatch('logout')
    }
  }
}
</script>
